const tableKeys = {
  playerAdjustments: 'playerAdjustments',
  bonusTemplates: 'bonusTemplates',
  promoCodes: 'promoCodes',
  bonuses: 'bonuses',
  sportBonus: 'sportBonus',
  casinoBonus: 'casinoBonus',
  spinBonus: 'spinBonus',
  specialBonus: 'specialBonus',
  playerSportBonus: 'playerSportBonus',
  playerCasinoBonus: 'playerCasinoBonus',
  playerSpinBonus: 'playerSpinBonus',
  playerSpecialBonus: 'playerSpecialBonus',
  playersReport: 'playersReport',
  cashBack: 'cashBack',
  playerCashBack: 'playerCashBack',
  testPlayers: 'testPlayers',
  testPlayerUsers: 'testPlayerUsers',
  similarAccounts: 'similarAccounts',
  playerSimilarAccounts: 'playerSimilarAccounts',
  referralManagement: 'referralManagement',
  users: 'users',
  playerReferralBonus: 'playerReferralBonus',
  userLogs: 'userLogs',
  playerLogs: 'playerLogs',
  userManagementLogs: 'userManagementLogs',
  playerLogsAccounts: 'playerLogsAccounts',
  financialWithdrawals: 'financialWithdrawals',
  financialDeposits: 'financialDeposits',
  playerFinancialDeposits: 'playerFinancialDeposits',
  playerFinancialWithdrawals: 'playerFinancialWithdrawals',
  userLogsAccounts: 'userLogsAccounts',
  playerNraLogs: 'playerNraLogs',
  playerSelfieKycLogs: 'playerSelfieKycLogs',
  closedAccounts: 'closedAccounts',
  playersTotals: 'playersTotals',
  casinoBets: 'casinoBets',
  sportBets: 'sportBets',
  playerCasinoBets: 'playerCasinoBets',
  playerSportBets: 'playerSportBets',
  transactions: 'transactions',
  selfExclusions: 'selfExclusions',
  timeLimits: 'timeLimits',
  transactionsByPlayer: 'transactionsByPlayer',
  amountLimits: 'amountLimits',
  transactionsByBrand: 'transactionsByBrand',
  negativeBalance: 'negativeBalance',
  liability: 'liability',
  blockedPlayers: 'blockedPlayers',
  brandAutomationRules: 'brandAutomationRules',
  balanceAdjustmentsReport: 'balanceAdjustmentsReport',
  playersWallets: 'playersWallets',
  playersWalletsV2: 'playersWalletsV2',
  betAggregationsByPlayer: 'betAggregationsByPlayer',
  betAggregationsByCurrency: 'betAggregationsByCurrency',
  kycReport: 'kycReport',
  financialAggregationsByPlayer: 'financialAggregationsByPlayer',
  financialAggregationsByCurrency: 'financialAggregationsByCurrency',
  gameManagementGames: 'gameManagementGames',
  gameManagementGameGroups: 'gameManagementGameGroups',
  brandPaymentMethods: 'brandPaymentMethods',
  playerLimitLogs: 'playerLimitLogs',
  reasons: 'reasons',
  campaigns: 'campaigns',
  campaignDepositStatistics: 'campaignDepositStatistics',
  campaignFailedDepositStatistics: 'campaignFailedDepositStatistics',
  campaignVerificationStatistics: 'campaignVerificationStatistics',
  campaignFailedVerificationStatistics: 'campaignFailedVerificationStatistics',
  campaignSignUpStatistics: 'campaignSignUpStatistics',
  campaignFailedSignUpStatistics: 'campaignFailedSignUpStatistics',
  campaignNoTriggerStatistics: 'campaignNoTriggerStatistics',
  campaignFailedNoTriggerStatistics: 'campaignFailedNoTriggerStatistics',
  externalSoftwareChanges: 'externalSoftwareChanges',
  externalGameRatio: 'externalGameRatio',
  externalPlayerExclusion: 'externalPlayerExclusion',
  externalGameTypes: 'externalGameTypes',
  externalBalanceAdjustment: 'externalBalanceAdjustment',
  externalSessions: 'externalSessions',
  externalSafeServer: 'externalSafeServer',
  externalMirroringServer: 'externalMirroringServer',
  externalJackPotWinRatio: 'externalJackPotWinRatio',
  externalJackPotConfiguration: 'externalJackPotConfiguration',
  externalPromotionalItems: 'externalPromotionalItems',
  externalSignificantEvents: 'externalSignificantEvents',
  externalServerInaccessibility: 'externalServerInaccessibility',
  externalLargeTransactions: 'externalLargeTransactions',
  externalRestrictions: 'externalRestrictions',
  previousAccountsGroups: 'previousAccountsGroups',
  previousAccounts: 'previousAccounts',
  playerPreviousAccounts: 'playerPreviousAccounts',
  lobbyProviders: 'lobbyProviders',
  crossPlatformCampaigns: 'crossPlatformCampaigns',
  promotions: 'promotions',
  promotionTransactions: 'promotionTransactions',
  promotionPrizes: 'promotionPrizes',
  promotionPlayers: 'promotionPlayers',
  changeNotification: 'changeNotification',
  promoSpinsAdjustments: 'promoSpinsAdjustments',
  exportHistory: 'exportHistory',
  playerSpins: 'playerSpins',
  playerTransactions: 'playerTransactions',
  promotionMachines: 'promotionMachines',
  providersByCalculatedBets: 'providersByCalculatedBets',
  providersByMixedBets: 'providersByMixedBets',
  firstDeposits: 'firstDeposits',
  taxationDaily: 'taxationDaily',
  taxationMonthly: 'taxationMonthly',
  bonusTotalsByPlayer: 'bonusTotalsByPlayer',
  bonusTotalsByType: 'bonusTotalsByType',
  bonusTotalsByStatus: 'bonusTotalsByStatus',
  singleBets: 'singleBets',
  bulkBets: 'bulkBets',
  bulkBetsStatistics: 'bulkBetsStatistics',
  inactivePlayers: 'inactivePlayers',
  promotionSpins: 'promotionSpins',
  promotionSpinStatistics: 'promotionSpinStatistics',
  topPlayersByGgr: 'topPlayersByGgr',
  topPlayersByDeposits: 'topPlayersByDeposits',
  topPlayersByWithdrawals: 'topPlayersByWithdrawals',
  releaseNotes: 'releaseNotes',
  gameTypes: 'gameTypes',
  campaignSignInStatistics: 'campaignSignInStatistics',
  campaignFailedSignInStatistics: 'campaignFailedSignInStatistics',
  bonusTotalsByProvider: 'bonusTotalsByProvider',
  applicationSessions: 'applicationSessions',
  webSessions: 'webSessions',
  promotionExchanges: 'promotionExchanges',
  promotionChangeLogs: 'promotionChangeLogs',
  lobbyGameGroups: 'lobbyGameGroups',
  campaignsV2: 'campaignsV2',
  crossPlatformCampaignsV2: 'crossPlatformCampaignsV2',
  sentMessages: 'sentMessages',
  scheduledMessages: 'scheduledMessages',
  draftMessages: 'draftMessages',
  homeWidgets: 'homeWidgets',
  playerComplaints: 'playerComplaints',
  campaignV2NoTriggerStatistics: 'campaignV2NoTriggerStatistics',
  campaignV2SignInStatistics: 'campaignV2SignInStatistics',
  campaignV2SignUpStatistics: 'campaignV2SignUpStatistics',
  campaignV2VerificationStatistics: 'campaignV2VerificationStatistics',
  campaignV2DepositStatistics: 'campaignV2DepositStatistics',
  campaignsV2Units: 'campaignsV2Units',
  campaignsV2Bonuses: 'campaignsV2Bonuses',
  campaignV2FreeBetBonus: 'campaignV2FreeBetBonus',
  campaignV2SpinBonus: 'campaignV2SpinBonus',
  campaignV2WagerBonus: 'campaignV2WagerBonus',
  campaignV2SpecialBonus: 'campaignV2SpecialBonus',
  crossPlatformCampaignV2Statistics: 'crossPlatformCampaignV2Statistics',
  selfAssessments: 'selfAssessments',
  playerFreeBetBonusV2: 'playerFreeBetBonusV2',
  playerSpinBonusV2: 'playerSpinBonusV2',
  playerCombinedBonusV2: 'playerCombinedBonusV2',
  playerSpecialBonusV2: 'playerSpecialBonusV2',
  navigationWidgets: 'navigationWidgets',
  promoCodesV2: 'promoCodesV2',
  cashBackV2: 'cashBackV2',
  playerCashBacksV2: 'playerCashBacksV2',
  campaignV2BetStatistics: 'campaignV2BetStatistics',
  campaignV2GameLaunchStatistics: 'campaignV2GameLaunchStatistics',
  taxation: 'taxation',
  campaignV2BonusStatistics: 'campaignV2BonusStatistics',
  playerCampaignV2Units: 'playerCampaignV2Units',
  brandsWallets: 'brandsWallets',
  episLogs: 'episLogs',
  campaignV2WithdrawalStatistics: 'campaignV2WithdrawalStatistics',
  campaignV2AutoDepositActivationStatistics: 'campaignV2AutoDepositActivationStatistics',
  periodicReportByPlayer: 'periodicReportByPlayer',
  taxationByCategory: 'taxationByCategory',
  taxationStatisticsByCategory: 'taxationStatisticsByCategory',
  taxationByPlayer: 'taxationByPlayer',
  taxationStatisticsByPlayer: 'taxationStatisticsByPlayer',
  requests: 'requests',
  bonusTotalsByPlayerV2: 'bonusTotalsByPlayerV2',
  bonusTotalsByTypeV2: 'bonusTotalsByTypeV2',
  bonusTotalsByStatusV2: 'bonusTotalsByStatusV2',
  gamStopLogs: 'gamStopLogs',
  gamStopLogsAccounts: 'gamStopLogsAccounts',
  nraLogs: 'nraLogs',
  selfieKycLogs: 'selfieKycLogs',
} as const;

const settingKeys = {
  menuCollapse: 'menuCollapse',
  pageSize: 'pageSize',
  timeZone: 'timeZone',
  languageId: 'languageId',
  isNightMode: 'isNightMode',
  brandSettingsExpand: 'brandSettingsExpand',
  playerPerformance: 'playerPerformance',
  betAggregationsByPlayerCriteria: 'betAggregationsByPlayerCriteria',
  betAggregationsByCurrencyCriteria: 'betAggregationsByCurrencyCriteria',
  playerMainInfoPosition: 'playerMainInfoPosition',
} as const;

const pageSizeKeys = {
  campaignsPageSize: 'campaignsPageSize',
  playersPageSize: 'playersPageSize',
} as const;

const filterKeys = {
  playersFilter: 'playersFilter',
  depositsFilter: 'depositsFilter',
  withdrawalsFilter: 'withdrawalsFilter',
  casinoFilter: 'casinoFilter',
  sportFilter: 'sportFilter',
  playerCasinoFilter: 'playerCasinoFilter',
  playerSportFilter: 'playerSportFilter',
} as const;

const tabKeys = {
  playerGeneralTab: 'playerGeneralTab',
  accountDetailsTab: 'accountDetailsTab',
  playerPaymentsTab: 'playerPaymentsTab',
  playerBetsTab: 'playerBetsTab',
  playerBonusesTab: 'playerBonusesTab',
  playerCommsTab: 'playerCommsTab',
  playerLimitsTab: 'playerLimitsTab',
  playerPromotionToolTab: 'playerPromotionToolTab',
  playerTagsTab: 'playerTagsTab',
  playerMonitoringTab: 'playerMonitoringTab',
  playerAuditLogsTab: 'playerAuditLogsTab',
  playerAttachmentTabs: 'playerAttachmentTabs',
  regulatoryTaxationTab: 'regulatoryTaxationTab',
  complianceLargeTransactionsTab: 'complianceLargeTransactionsTab',
  compliancePlayerLimitsTab: 'compliancePlayerLimitsTab',
  biReportsTabs: 'biReportsTabs',
  biBetAggregationsTab: 'biBetAggregationsTab',
  financialReportsTabs: 'financialReportsTabs',
  biFinancialAggregationsTab: 'biFinancialAggregationsTab',
  romanianReportsTabs: 'romanianReportsTabs',
  complianceReportsTabs: 'complianceReportsTabs',
  brandLocationTab: 'brandLocationTab',
  campaignsDepositStatisticsTabs: 'campaignsDepositStatisticsTabs',
  campaignsSignUpStatisticsTabs: 'campaignsSignUpStatisticsTabs',
  campaignsVerificationStatisticsTabs: 'campaignsVerificationStatisticsTabs',
  campaignsNoTriggerStatisticsTabs: 'campaignsNoTriggerStatisticsTabs',
  campaignsSignInStatisticsTabs: 'campaignsSignInStatisticsTabs',
  casinoProductTabs: 'casinoProductTabs',
  auditLogTabs: 'auditLogTabs',
  betStatusCorrectionsTabs: 'betStatusCorrectionsTabs',
  cashBackStatisticsTabs: 'cashBackStatisticsTabs',
  betTabs: 'betTabs',
  bonusReportsTabs: 'bonusReportsTabs',
  devToolTabs: 'devToolTabs',
  bonusesTabs: 'bonusesTabs',
  paymentMethodViewTabs: 'paymentMethodViewTabs',
  reasonsSystemTabs: 'reasonsSystemTabs',
  referralStatisticsTabs: 'referralStatisticsTabs',
  tagCategoriesTabs: 'tagCategoriesTabs',
  translationTabs: 'translationTabs',
  operatorLimitsTabs: 'operatorLimitsTabs',
  notificationTabs: 'notificationTabs',
  conversionTabs: 'conversionTabs',
  brandMainSettingsTabs: 'brandMainSettingsTabs',
  pushNotifications: 'pushNotifications',
  promotionStatisticsTabs: 'promotionStatisticsTabs',
  playerReportsTabs: 'playerReportsTabs',
  massMessagesTabs: 'massMessagesTabs',
  gameManagementTabs: 'gameManagementTabs',
  brandTaxesTabs: 'brandTaxesTabs',
  sportsBookTabs: 'sportsBookTabs',
  brandPaymentsTabs: 'brandPaymentsTabs',
  brandPaymentMethodTabs: 'brandPaymentMethodTabs',
  brandThirdPartyServicesTabs: 'brandThirdPartyServicesTabs',
  bulkActionsTabs: 'bulkActionsTabs',
  campaignsTabs: 'campaignsTabs',
  cashierTabs: 'cashierTabs',
  paymentMethodConfigurationTabs: 'paymentMethodConfigurationTabs',
  playerTagTabs: 'playerTagTabs',
  reportingTopPlayersTabs: 'reportingTopPlayersTabs',
  regulatoryTaxationTabs: 'regulatoryTaxationTabs',
  deviceSessionsTabs: 'deviceSessionsTabs',
  blockAccessTabs: 'blockAccessTabs',
  lobbyWidgetsTabs: 'lobbyWidgetsTabs',
  campaignV2BonusesTabs: 'campaignV2BonusesTabs',
  playerBonusesTabV2: 'playerBonusesTabV2',
  playerSessionTab: 'playerSessionTab',
  segmentTabs: 'segmentTabs',
  systemSettingsTab: 'systemSettingsTab',
  financialsWalletsTab: 'financialsWalletsTab',
  taxationTabs: 'taxationTabs',
  brandBonusManagementTabs: 'brandBonusManagementTabs',
} as const;

export {
  tableKeys, settingKeys, pageSizeKeys, filterKeys, tabKeys,
};
